import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const PAGINATION_SIZE_OPTIONS = [10, 25, 50, 100];

const DataTablePagination = ({
  totalItems = 0,
  itemsPerPage = 10,
  currentPage = 1,
  onItemsPerPageChange,
  onPageChange,
  activePageClass = 'bg-orange-500 text-white',
  selectFocusClass = 'focus:border-orange-500',
}) => {
  if (totalItems <= 0) return null;

  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));
  const safeCurrentPage = Math.min(Math.max(currentPage, 1), totalPages);
  const startItem = (safeCurrentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(safeCurrentPage * itemsPerPage, totalItems);

  return (
    <div className="flex flex-col md:flex-row items-center justify-between gap-4 mt-6 pt-6 border-t border-slate-800">
      <div className="flex items-center gap-3 flex-wrap">
        <span className="text-xs text-slate-500 uppercase font-bold">Itens por página:</span>
        <select
          value={itemsPerPage}
          onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
          className={`bg-slate-900 border border-slate-800 text-slate-300 text-xs rounded-lg px-2 py-1 outline-none transition ${selectFocusClass}`}
        >
          {PAGINATION_SIZE_OPTIONS.map((option) => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
        <span className="text-xs text-slate-500">
          Mostrando {startItem}-{endItem} de {totalItems}
        </span>
      </div>

      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => onPageChange(Math.max(safeCurrentPage - 1, 1))}
          disabled={safeCurrentPage === 1}
          className="p-2 bg-slate-900 border border-slate-800 rounded-lg text-slate-500 hover:text-white disabled:opacity-30 disabled:cursor-not-allowed transition"
        >
          <ChevronLeft size={18} />
        </button>

        <div className="flex items-center gap-1">
          {[...Array(totalPages)].map((_, i) => {
            const pageNum = i + 1;
            if (
              pageNum === 1 ||
              pageNum === totalPages ||
              (pageNum >= safeCurrentPage - 1 && pageNum <= safeCurrentPage + 1)
            ) {
              return (
                <button
                  type="button"
                  key={pageNum}
                  onClick={() => onPageChange(pageNum)}
                  className={`w-8 h-8 rounded-lg text-xs font-bold transition ${safeCurrentPage === pageNum ? activePageClass : 'bg-slate-900 text-slate-500 hover:text-white border border-slate-800'}`}
                >
                  {pageNum}
                </button>
              );
            }

            if (pageNum === safeCurrentPage - 2 || pageNum === safeCurrentPage + 2) {
              return <span key={pageNum} className="text-slate-700 px-1">...</span>;
            }

            return null;
          })}
        </div>

        <button
          type="button"
          onClick={() => onPageChange(Math.min(safeCurrentPage + 1, totalPages))}
          disabled={safeCurrentPage === totalPages}
          className="p-2 bg-slate-900 border border-slate-800 rounded-lg text-slate-500 hover:text-white disabled:opacity-30 disabled:cursor-not-allowed transition"
        >
          <ChevronRight size={18} />
        </button>
      </div>
    </div>
  );
};

export default DataTablePagination;
